import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Preference } from '../../../../avisDePub/preferences-avis-de-pub/model/preference';
import { Step4 } from '../../../../shared/models/component-messages/simp_in/step4';
import { Lot } from '../models/Lot';
@Component({
	selector: 'app-lot',
	templateUrl: './lot.component.html'
})
export class LotComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'Lot';
	@Input() parentForm: FormGroup;

	@Input() disabled: boolean;
	@Input() lot: Lot;
	@Input() i = 0;

  @Output() prefEmit: EventEmitter<Preference>  = new EventEmitter();

	public step4 = new Step4();

	constructor() {}

	public ngOnInit() {}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}

	getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	}

  chargeDonneePreference(preference: Preference) {
    this.prefEmit.emit(preference);
  }
}
